module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_c('i', [_vm._v("Facebook")])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-1"
  }, [_c('div', {
    staticClass: "img h1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-11"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_c('b', [_vm._v("Facebook Name")]), _c('br'), _vm._v(" Age of Post")]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. @ImpactJournals Aenean euismod bibendum laoreet.\n            Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor."), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-8"
  }, [_c('div', {
    staticClass: "img h2"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('h5', [_c('i', [_vm._v("Post Headline")])]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. @ImpactJournals Aenean euismod bibendum laoreet.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fa17ca0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/publications/article-detail/MediaFacebookPage.vue
// module id = 1423
// module chunks = 1